module.exports = __webpack_public_path__ + "static/media/react-native.59760d8d.png";